import { Head, CleanContent } from './ui';
import { signals } from '../data';

export default function TrustSignals() {
  return (
    <CleanContent><section className="bg-soft py-5">
        <div className="container">
          <Head eyebrow="Anti Fraud Architecture" title="Real Users, Real Engagement, Real Signals"
            text="SELECTEZI monitors activity authenticity in real time: we engineer out vanity metrics and prioritize verifiably genuine corporate connections" />
          <div className="row g-3 mb-4">
            {signals.map(([ic, t, d]) => (
              <div className="col-6 col-lg-3" key={t}>
                <div className="bg-white border border-line rounded-3 p-3 h-100">
                  <div className="icon-box rounded-2 d-flex align-items-center justify-content-center mb-2"><i className={`bi ${ic}`} /></div>
                  <div className="h-md mb-1">{t}</div><p className="p-sm mb-0">{d}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="row g-3">
            <div className="col-md-6">
              <div className="bg-white border border-line rounded-3 p-4 h-100">
                <span className="badge tag-red mb-2">ARTIFICIAL POPULARITY</span>
                <div className="h-md mb-2">10,000 Low Quality Bot Likes</div>
                <p className="p-sm">Purchased followers, click farms, and coordinated review bursts yield 0 Star Impact while automated fraud detection tags the profile, dampening visibility index</p>
                <span className="badge tag-red">Status: Excluded from Star Calculation</span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="bg-blue rounded-3 p-4 h-100">
                <span className="badge bg-light text-primary mb-2">GENUINE BUSINESS ENGAGEMENT</span>
                <div className="h-md mb-2">2,000 Engaged Enterprise Users</div>
                <p className="p-md">Verified business inquiries, consistent RFQ closures, high responsiveness, and substantive evaluations lead to genuine rank progression</p>
                <span className="badge bg-light text-success">Status: Fully Validated & Star Accredited</span>
              </div>
            </div>
          </div>
        </div>
      </section></CleanContent>
  );
}
